import { ReleaseInfoType } from '../../../utils/type';
import { ApiResponseHandler } from '../../ApiResponseHandler';
import ThomApiClient from '../../ThomApiClient';

export const getWebAppDetails = async (): Promise<ReleaseInfoType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<ReleaseInfoType>(
      `api/os-info/latest`,
    ),
  );
};
